module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-workflow-content"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('org-contact-assign', {
    attrs: {
      "row-data": _vm.taskData,
      "row-index": _vm.rowIndex
    }
  })], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('checklist-table', {
    attrs: {
      "parent-data": _vm.rowData,
      "isSite": true,
      "percent-complete": _vm.rowData.percentComplete,
      "tableTitle": _vm.tableTitle
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d25f4b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/site/SiteWorkflowDetails.vue
// module id = 1644
// module chunks = 0